/**
 * APIコール ユーティリティ
 */
const _apiClient = {
  /** お知らせ取得 */
  getNews: (options?: ApiOptions<GetNewsReq, GetNewsRes>) => new Promise<GetNewsRes>(() => { }),
  /** 会社・採用情報取得 */
  getInformation: (options?: ApiOptions<GetInfomationReq, GetInfomationRes>) => new Promise<GetInfomationRes>(() => { })
}

/** 許可メソッド一覧 */
const ENABLE_METHODS = ['get', 'post']

/** WebAPI クライアント */
export const apiClient = new Proxy(_apiClient, {
  get(_target, prop: string, _receiver) {
    // APIリクエスト開始
    return (options?: ApiOptions<any, any>) =>
      new Promise<APIBaseRes>(async (resolve, reject) => {
        // リクエストメソッドとパスの情報に分解
        const [method, ...paths] = prop.split(/(?=[A-Z])/)
        // 不許可メソッドはrejectではじく
        if (ENABLE_METHODS.includes(method) === false) {
          reject(
            console.error(`許可されていないメソッド(${method})が使用されています。`)
          )
        }

        // リクエストヘッダの生成
        const headers: any = {
          Accept: options?.headers?.accept || 'application/json',
          'Content-Type':
            options?.headers?.contentType || 'application/json',
          'X-MICROCMS-API-KEY': process.env.REACT_APP_API_KEY,
        }

        // それぞれ状況に応じて取得先を切り替える
        if (options?.mock) {
          // モックファイルが指定されている場合
          console.debug(options?.mock, options)
          // モックファイルパスからJSONファイルを取得
          const targetPath = '/mock/' + options.mock
          fetch(targetPath, {
            headers: headers,
            method: 'get'
          })
            .then(response => response.json())
            .then(data => {
              // データを処理するコードをここに記述
              resolve(data)
            })
            .catch(error => {
              console.error('リクエストエラー:', error);
            });
        } else if (process.env.REACT_APP_MOCK_MODE === 'true') {
          // モック表示モードの場合
          console.debug(options?.mock, options)
          // モックの場合はパスからJSONファイルを取得
          const targetPath =
            '/mock/' +
            method.charAt(0).toUpperCase() +
            method.slice(1) +
            paths.join('') +
            '.json'
          fetch(targetPath, {
            headers: headers,
            method: 'get'
          })
            .then(response => response.json())
            .then(data => {
              // データを処理するコードをここに記述
              resolve(data)
            })
            .catch(error => {
              console.error('リクエストエラー:', error);
            });
        } else {
          // APIリクエスト先のパスを生成
          let targetPath = process.env.REACT_APP_API_BASE + paths.join('-').toLowerCase()
          if (options?.pathParams?.length) {
            // パスパラメータがあれば結合する
            targetPath = [targetPath, ...options.pathParams].join(
              '/'
            )
          }
          if (options?.queryParams?.length) {
            const urlSearchParam = new URLSearchParams(options?.queryParams)
            // クエリパラメータがあれば結合する
            targetPath = targetPath + '?' + urlSearchParam
          }
          fetch(targetPath, {
            headers: headers,
            method: method,
            body:
              method !== 'get'
                ? JSON.stringify(options?.requestData || {}) : undefined
          })
            .then(response => {
              // データを処理するコードをここに記述
              resolve(response.json())
            })
            .catch(error => {
              reject(error)
            })
        }
      })
  }
})
